export enum AccidentRoleType {
  Driver="driver",
  Passenger="passenger",
  Pedestrian="pedestrian",
  NotInvolved="not-involved",
}
